/**
 * Default Arena design tokens aligned with `webapp/style/_vars.scss`.
 */
export const defaultTokens = {
  typography: {
    fontFamily: "'Noto Sans', sans-serif",
  },
  colors: {
    red: '#ed5b46',
    green: '#84ac67',
    yellow: '#fee997',
    grey: '#e7e9ee',
    greyAppBg: '#f6f7f9',
    greyBorder: '#d1d1dd',
    blue: '#3885ca',
    blueLight: '#c5dbf0',
    blueLightFocus: '#edf4fa',
    blueLightActive: '#9dc3e5',
    blueDark: '#21507b',
    orange: '#eba444',
    black: '#2f3138',
    white: '#ffffff',
    colorTextPrimary: '#21507b',
  },
} as const

export type ArenaTokens = typeof defaultTokens
